import { render, staticRenderFns } from "./GeneratorStartButtons.vue?vue&type=template&id=54786e8a&"
import script from "./GeneratorStartButtons.vue?vue&type=script&lang=js&"
export * from "./GeneratorStartButtons.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorStartButtons.vue?vue&type=style&index=0&id=54786e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports